import * as React from "react";
import { Dialog, DialogContent } from "@material-ui/core";
import { Datagrid, List, TextField } from "react-admin";

export const ShopReportFields = props => {
  const [open, setOpen] = React.useState(props.open);

  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  const handleClose = () => {
    setOpen(false);
    props?.handleClose?.();
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogContent>
          <List
            {...props}
            title={"Shop Report Fields"}
            hasCreate={false}
            resource="vwshopreportfields"
            basePath=""
            hasBulkActions={false}
            bulkActionButtons={false}
            exporter={false}
            filterDefaultValues={{
              wo__eq: props?.shopReport?.wo,
            }}
          >
            <Datagrid {...props} optimized hasBulkActions={false} style={{ height: "auto" }}>
              <TextField source="wo" label="Wo" />
              <TextField source="shopFinding" label="Shop Finding" />
              <TextField source="workDone" label="Work Done" />
              <TextField source="usedMaterials" label="Used Materials" />
            </Datagrid>
          </List>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default ShopReportFields;
